import { IUntypedQuery, Topics } from '@zaplify/common';

export class GetJobTitleAutoCompleteQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly query: string) {
        super();
    }
}
